import { Button } from "@material-ui/core";
import { Cancel } from "@material-ui/icons";
import { useCallback } from "react";
import { Create, TopToolbar, useNotify, useRedirect, useRefresh } from "react-admin";
import { useUploadHook } from "../../utils/upload.hook";
import { FormsForm } from "./component/forms.form";

const FormsCreate = (props) => {
	const upload = useUploadHook();
	const redirect = useRedirect()
	const notify = useNotify()
	const refresh = useRefresh()

	const onSuccess = ({ data }) => {
		notify('Fomulário criado com sucesso')
		redirect('/forms', undefined, {}, {}, { data })
		refresh()
	}

	const onTransform = useCallback(async (data) => {
		if (data.attachment) {
			const attachment = await upload.uploadFile(data.attachment.rawFile, 'forms')
			return { ...data, attachment };
		}
		return data;
	}, [upload])

	const CancelToolbar = ({ basePath, data }) => {
		return (
			<TopToolbar>
				<Button onClick={() => redirect(`${basePath}`)} startIcon={<Cancel />} children={'Cancelar'} />
			</TopToolbar>
		)
	};

	return (
		<Create
			{...props}
			onSuccess={onSuccess}
			transform={onTransform}
			actions={<CancelToolbar />}
		>
			<FormsForm />
		</Create>
	)
}

export default FormsCreate;